import { smartDocParamType_Dynamic } from './dynamic/index.js';
import { smartDocParamType_EHR } from './ehr/index.js';
import { smartDocParamType_External } from './external/index.js';
import { smartDocParamType_Static } from './static/index.js';
export const smartDocParamTypeLabelMap = {
    [smartDocParamType_Static]: 'Static',
    [smartDocParamType_Dynamic]: 'Dynamic',
    [smartDocParamType_External]: 'External',
    [smartDocParamType_EHR]: 'EHR',
};
//# sourceMappingURL=consts.js.map